export enum AnalyticEventName {
  LOGIN = 'login',
}
